import Vue                  from "vue";
import { mapGetters }       from "vuex"
import { LoadingSpinner }   from "@/components";
import { 
    TmsService,
    ErrorLogService,
    PartsService  }         from "@/services/";
 
    
import TmsPartInfo          from "@/components/TruckModelSearch/TmsPartInfo.vue"
import PaginationText       from "@/components/Elements/PaginationText.vue";
import { DnRouterLink }     from "@/components/Elements";
import PartSearchFacets     from "@/components/SubMenus/PartSearchFacets.vue";
import { themeHelper }      from "@/components/mixins/themeHelper";
import {constants}           from "@/const" 
import { UserSettingsService }    from "@/services";
import { default as TruckModelSearch } from "@/components/TruckModelSearch/TruckModelSearch.vue";

const doNotAddSelectedFacets = ["OemDescription", "Model", "Page", "com"];

//These are added by Global Login, and are not relevant to TMS
const ignoredQueryStringParams = ["auid", "cnt"]

export default Vue.extend({
    name: "TmsIndex",
    components: {
        LoadingSpinner,
        TmsPartInfo,
        PaginationText,
        PartSearchFacets,
        DnRouterLink,
        TruckModelSearch
    },
    mixins: [
        themeHelper
    ],
    created() {
        let facets = {};
        let self = this;

        // loop through query string and assign each query prop and value to facets
        // also build up the selectedFacets to show in the side facet menu
        Object.keys(this.$route.query).forEach(function (prop) {
            if(ignoredQueryStringParams.includes(prop)){
                return;
            }
            facets[prop] = self.$route.query[prop];
            if (!doNotAddSelectedFacets.includes(prop)) {
                if(!self.selectedFacets[""])
                self.selectedFacets[prop] = self.$route.query[prop];
            }
        });
        
        // if 'Page' is not present, add it.
        if (this.IsNullOrUndefined(facets["Page"])) {
            facets["Page"] = 1;
        }

        // Setting facet Keyword Search box to the keyword search value. In query string this is Part_Description
        if (this.selectedFacets["Part_Description"]) {
            this.searchTerm = this.selectedFacets["Part_Description"];
            delete this.selectedFacets["Part_Description"];
        }
        
        // save to data for use with pagination and facet searching
        this.queryFacets = facets;
        this.loadBreadcrumbs = true;
        this.getCategories();
    },
    computed: {
        ...mapGetters([
            "user",
            "audienceIds",
            "activeAccountId",
            "getContentItem",
            "partSearchDefaultSort",
            "collapseAllPartDescriptionsValue",
            "CurrentCategory"
        ]),
    },
  mounted() {
    this.getUserSettings();
  },
    data: () => ({
        isTms: true,
        searchTerm: "",
        searchResults: {},
        loadingSearchResults: true,
        queryFacets: {},
        selectedFacets: {},
        hasAltParts: false,
        totalParts: 0,
        totalPartPages: 0,
        partsPerPage: 10,
        breadcrumbDivider: "/",
        userpartSearchDefaultSort: "",
        sortByOptions: constants.SORT_BY_OPTIONS,
        selectedSortTerm: "",
        defaultSortTerm: "",
        defaultSortDirection: "",
        currentSearchTerms: null,
        SearchId: String,
        categories: []
    }),
    props: {

    },
    methods: {
        async getUserSettings(){
            this.loadingUserSettings = true;
            // This handles a refresh from the user settings page
            if (this.userSettings === undefined || this.userSettings.length === 0){
              await UserSettingsService.GetUserSettings(this.user.UserId)
                .then( userSettings => {
                  this.$store.commit("SET_USER_SETTINGS_TMS", userSettings)
                });
            }
      
            this.userCollapsePartDescriptions = await this.collapseAllPartDescriptions;
            this.userpartSearchDefaultSort = await this.partSearchDefaultSort;
            this.loadingUserSettings = false;

          },        
        GetSearchInputWithoutFacets() {
            return {
                AccountId: this.activeAccountId,
                UserId: this.user.UserId,
                DealerCode: this.user.DealerCode,
                Audiences: this.audienceIds,
                SortField: this.sortTerm,
                SortDirection: this.sortDirection,
                InStockFilter: this.inStockFilter,
            }
        },
        HasAltParts(emittedHasAlts: boolean) {
            if (this.hasAltParts) {
                return;
            }
            this.hasAltParts = emittedHasAlts;
        },
        redirectToTruckSelect() {
            let query = {};
            query["make"] = this.queryFacets["OemDescription"];
            query["model"] = this.queryFacets["Model"];

            this.$router.push({ name: "TruckSelection", query });
        },
        async getCategories(){

            var make = this.queryFacets["OemDescription"];
            var model = this.queryFacets["Model"];

            var searchInput = {
                AccountId: this.activeAccountId,
                UserId: this.user.UserId,
                DealerCode: this.user.DealerCode,
                Audiences: this.audienceIds,
                Facets: {
                    "OemDescription": make,
                    "Model": model
                }
            };

            this.categories = (await TmsService.GetCategories(searchInput)).data;

        },
        setSerialPrefixOnSerialRangeSelect(query: Object, prop: string) {
            let prefixKeyArray = [String];
            prefixKeyArray.splice(0,1); // remove empty first element
            this.searchResults.Facets.Serial_Prefix.forEach(function(kvp: any) {
                prefixKeyArray.push(kvp.Key);
            })
            
            // bail out of here if there are not any prefixes
            if (prefixKeyArray == undefined) {
                return;
            }
            
            let prefixLength = prefixKeyArray[0].length;            
            let prefix = this.selectedFacets[prop].substring(0, prefixLength);            
            
            // only add prefix if the Serial_Range starts with a prefix in the array.
            if (prefixKeyArray.includes(prefix)) {
                query["Serial_Prefix"] = prefix;
            }
        },
        UpdateFacets() {
            this.$store.commit("SET_RECENT_COMPONENT", {
                name: `Tms_Facets_${this.searchResults.OemDescription}_${this.searchResults.Model}`,
                data: this.selectedFacets,
            });

            var query = {};
            query["OemDescription"] = this.queryFacets["OemDescription"];
            query["Model"] = this.queryFacets["Model"];

            let self = this;
            // loop through selectedFacets and add them to the queryFacets to get all params for search
            Object.keys(this.selectedFacets).forEach(function (prop) {
                if (prop === "Serial_Range") {
                    self.setSerialPrefixOnSerialRangeSelect(query, prop);
                }
                query[prop] = self.selectedFacets[prop];
            });

            // reset page back to 1
            query["Page"] = 1;

            // Need to use local object for the search. .push method will not accept "this.{}"
            this.$router.push({ name: "TruckModelSearch", query });
        },
        async getCategoryParts(sortTerm, sortDirection,pageNumber,inStockFilter) {
            this.loadingSearchResults = true;
            this.queryFacets["Page"] = pageNumber;
            let searchInput = this.GetSearchInputWithoutFacets();
            searchInput.SortField = sortTerm;
            searchInput.SortDirection = sortDirection;
            searchInput.Facets = this.queryFacets;
            searchInput.InStockFilter = inStockFilter;
            this.currentSearchTerms = searchInput;
            var currentParts; 
            var countPartsLoaded = 0;
            this.hasAltParts = false;

            try{
            await new Promise((resolve) => { 
            TmsService.GetPartSearchResults(searchInput)
            .then((searchResults: any) => {
                this.searchResults = searchResults.data;
                this.totalParts = this.searchResults.TotalCount;
                this.totalPartPages = Math.ceil(this.totalParts / 10);
                currentParts = this.searchResults.Parts;

                // remove Category from facets so doesn't show in side menu (chosen category from part selection)
                delete this.searchResults.Facets["Category"];

                // show part details for the 10 we are showing on the page
                this.searchResults.Parts.forEach((part, index) => {
                    var partCode = part.PartCode;
                    if(!partCode){
                        partCode = part.OemPartCode;
                    }
                    PartsService.FullPartDetails(this.activeAccountId, this.user.UserId, part.PartId, this.audienceIds, partCode)
                        .then((fullPartDetail) => {
                            //Need to use $set here so that the new FullPartDetails property is added to vue reactivity
                            this.$set(currentParts[index], "FullPartDetails", fullPartDetail.data);
                        })
                        .catch((err) => {
                            ErrorLogService.LogException(err);
                        })
                        .finally(() => {
                            // Set FullPartDetails values if came back empty
                            if(part.FullPartDetails && this.IsNullOrUndefined(part.FullPartDetails.OemPartCode)){
                                part.FullPartDetails.OemPartCode = part.OemPartCode;
                                part.FullPartDetails.PartDescription = part.PopularDescription;
                            }
                            this.$set(currentParts[index], "OemInformation", part.OemInformation);

                            if(++countPartsLoaded === currentParts.length){
                                resolve(0);
                            }
                        });
                        this.$set(currentParts[index], "OemInformation", part.OemInformation);

                })
              })
              .catch((err) => {
                ErrorLogService.LogException(err);
              })
              .finally(() => {
                this.loadingSearchResults = false;
              });
            }).then(() => {
                //Make sure our search terms are the same before moving forward with updating the view (incase of spam clicks on pagination)
                if(this.currentSearchTerms === searchInput){
                    this.searchResults.Parts = currentParts;
                }
            })
            }
            catch(ex){
                ErrorLogService.LogException(ex);
            }
        },
        GetCurrentUrl(){
            var result = window.location.pathname + window.location.search;
            return result;
        }
    }
});
